import { useMemo } from 'react';

import { isFeatureEnabled } from '@/utils/millesimaUtils';

export const useFeature = (storeConf, feature) => (
  useMemo(() => isFeatureEnabled(storeConf, feature), [feature])
);
